import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  forwardRef,
} from "@angular/core";
import { Subject, Subscription, debounceTime } from "rxjs";
import { Constant } from "../../../core/constant";
import { NumberUtil } from "../../util/number.util";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "input-number",
  templateUrl: "./input-number.html",
  styleUrls: ["./input-number.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
  ],
})
export class InputNumberComponent implements OnInit, OnChanges {
  @Input("amount") amount: any;
  @Input("unit") unit: any;
  @Input("maxLength") maxLength: number = 12;
  @Input("placeholder") placeholder: any;
  @Input("disabled") disabled: boolean = false;
  @Input("isDecimal") isDecimal: boolean = false;
  @Input("isPercent") isPercent: boolean = false;
  @Input("maxLengthDecimal") maxLengthDecimal: number = 2;
  @Input("isInteger") isInteger: boolean = true;
  @Input("isSeparate") isSeparate: boolean = true;
  @Input("isError") isError: boolean = false;
  @Input("isHaveBtn") isHaveBtn: boolean = false;
  @Input("isTextAlignCenter") isTextAlignCenter: boolean = false;
  @Input("maxAvailable") maxAvailable: number;
  @Output() amountChange: EventEmitter<any> = new EventEmitter();
  @Output() result: EventEmitter<any> = new EventEmitter();
  amountText: string = "";
  Constant = Constant;
  changeInputText$ = new Subject();
  beforeKeydown: any;
  minValue: any;
  maxValue: any;
  @Input("id") id: string =
    "" + Math.round(Math.random() * 1000) + Math.round(Math.random() * 1000);
  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdf: ChangeDetectorRef) {}
  ngOnInit() {
    this.changeInputText$.pipe(debounceTime(100)).subscribe((event) => {
      return this.parseData();
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.amount) {
      if (!NumberUtil.isNull(changes.amount.currentValue)) {
        this.changeAmount(changes.amount.currentValue);
      } else {
        this.amountText = "";
      }
    }
    if (
      changes.maxAvailable &&
      !NumberUtil.isNull(changes.maxAvailable.currentValue)
    ) {
      this.maxValue = Number(changes.maxAvailable.currentValue);
      if (!NumberUtil.isNull(this.amount) && this.amount > this.maxValue) {
        this.amount = this.maxValue;
        this.amountText = this.isSeparate
          ? NumberUtil.numberToMoney(this.amount)
          : this.amount + "";
      }
    }
    if (changes.maxLength && changes.maxLength.currentValue) {
      this.findMaxAndMinValue();
    }
    if (changes.maxLengthDecimal && changes.maxLengthDecimal.currentValue) {
      this.findMaxAndMinValue();
    }
    if (changes.isPercent && changes.isPercent.currentValue) {
      setTimeout(() => {
        this.isDecimal = true;
        this.maxLengthDecimal = 2;
        this.maxLength = 3;
        this.maxValue = this.maxValue || 100;
        this.minValue = this.minValue || 0;
        this.unit = "%";
      }, 100);
    }
  }
  changeAmount(currentValue) {
    const amountRemoveComma = this.amountText
      ? NumberUtil.removeCommaForString(this.amountText)
      : null;
    if (amountRemoveComma) {
      if (!amountRemoveComma.includes(currentValue + "")) {
        this.changeText();
      }
    } else {
      this.changeText();
    }
  }
  writeValue(currentValue: any): void {
    this.amount = currentValue;
    this.changeAmount(currentValue);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  findMaxAndMinValue() {
    let max = "";
    for (let i = 0; i < this.maxLength; i++) {
      max += "9";
    }
    if (this.isDecimal) {
      max += ".";
      for (let i = 0; i < this.maxLengthDecimal; i++) {
        max += "9";
      }
    }
    if (!this.maxValue) {
      this.maxValue = parseFloat(max);
    }
    if (!this.minValue) {
      this.minValue = this.maxValue * -1;
    }
  }
  changeValue() {
    this.changeInputText$.next(true);
  }
  parseData() {
    this.checkValidateData();
    this.amountChange.emit(this.amount);
    this.onChange(this.amount);
    setTimeout(() => {
      this.result.emit(this.amount);
    }, 10);
  }
  checkValidateData() {
    if (
      this.amountText &&
      this.amountText !== "-" &&
      isNaN(parseFloat(this.amountText))
    ) {
      this.amount = null;
      this.amountText = null;
      return;
    }
    if (this.amountText === "") {
      this.amount = null;
      return;
    }
    let isNegative = false;
    let amountText = this.amountText;
    if (this.amountText[0] === "-") {
      isNegative = true;
      amountText = this.amountText.substring(1);
    }
    if (this.isSeparate) {
      const amount = amountText
        ? NumberUtil.revertMoneytoNumber(amountText)
        : null;
      this.amount = !NumberUtil.isNull(amount)
        ? amount * (isNegative ? -1 : 1)
        : null;

      if (this.amount === null) {
        return;
      }
      if (this.isDecimal) {
        this.amount = NumberUtil.decimalAdjust(
          this.amount,
          this.maxLengthDecimal,
        );
      } else {
        this.amount = Math.round(this.amount);
      }

      if (this.isInteger) {
        if (this.amount < 0) {
          this.amount = this.amount * -1;
          this.amountText = this.amount + "";
        }
      }
      this.addComma();
    } else {
      this.amount = amountText || null;
      const length = (Math.abs(this.amount) + "").length;
      if (length > this.maxLength) {
        this.amount = this.amount.slice(0, this.maxLength);
        this.cdf.detectChanges();
      }
    }
    if (
      this.maxAvailable !== null &&
      this.maxAvailable !== undefined &&
      this.amount !== null &&
      this.amount > this.maxAvailable
    ) {
      this.amount = this.maxAvailable;
      this.amountText = this.isSeparate
        ? NumberUtil.numberToMoney(this.amount)
        : this.amount + "";
    }

    // check length number
    this.checkMaxAndMinValue();

    if (this.amount === null) {
      return;
    }
  }
  addComma() {
    let amountText = NumberUtil.removeCommaForString(this.amountText);
    const split = amountText.split(".");
    this.amountText =
      NumberUtil.numberToMoney(split[0]) +
      (split.length > 1 ? "." + split[1] : "");
  }
  checkMaxAndMinValue() {
    // if (this.amountText.length < 2) {
    //     return;
    // }
    if (this.amount < this.minValue) {
      this.amount = this.minValue;
      this.amountText = NumberUtil.numberToMoney(this.amount);
    }

    if (this.amount > this.maxValue) {
      this.amount = this.maxValue;
      this.amountText = NumberUtil.numberToMoney(this.amount);
    }
  }
  changeText() {
    if (!this.isSeparate) {
      this.amountText = !NumberUtil.isNull(this.amount) ? this.amount + "" : "";
      return;
    }
    let changeText = !NumberUtil.isNull(this.amount)
      ? NumberUtil.numberToMoney(this.amount)
      : "";
    if (this.checkDifferentText(changeText)) {
      this.amountText = changeText;
    }
  }
  checkDifferentText(changeText) {
    if (changeText === "0") {
      let amountText = this.amountText.replaceAll(".", "");
      amountText = amountText.replaceAll(",", "");
      return parseInt(changeText) !== parseInt(amountText);
    }
    if ("-" === this.amountText) {
      return false;
    }
    if (changeText + "." === this.amountText) {
      return false;
    }
    return true;
  }
  catchKeydown(event) {
    const key = event.key;
    // input decimal
    if (this.isDecimal && key === ".") {
      const amount = (this.amountText || "").replaceAll(",", "");
      const positionDots = amount.indexOf(".");
      if (positionDots > -1) {
        event.preventDefault();
      }
      return;
    }

    // input negative
    if (!this.isInteger && key === "-") {
      return;
    }

    if (
      key === "Backspace" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab" ||
      key === "Delete"
    ) {
      return;
    }
    if (key === "Control") {
      this.beforeKeydown = key;
    }

    if (key === "v" && this.beforeKeydown === "Control") {
      this.beforeKeydown = "";
      return;
    }

    if (key === "c" && this.beforeKeydown === "Control") {
      this.beforeKeydown = "";
      return;
    }
    if (key === "a" && this.beforeKeydown === "Control") {
      this.beforeKeydown = "";
      return;
    }
    if (key === "x" && this.beforeKeydown === "Control") {
      this.beforeKeydown = "";
      return;
    }

    if (key >= "0" && key <= "9") {
      const selection: any = document.getSelection();
      if (
        selection.toString() &&
        selection.baseNode.id === "input-group-" + this.id
      ) {
        return;
      }
      let amount = (this.amountText || "").replaceAll(",", "");
      let isNegative = false;
      if (amount[0] === "-") {
        isNegative = true;
        amount = amount.substring(1);
      }
      if (!this.isSeparate && amount.length === this.maxLength) {
        event.preventDefault();
        return;
      }
      const textField: any = document.getElementById("input-" + this.id);
      const cursorPosition = textField.selectionStart;
      const positionDots = amount.indexOf(".");
      if (cursorPosition <= positionDots || positionDots === -1) {
        if (this.maxLength) {
          const lengthNumber = ((amount + "").split(".")[0] || "").length;
          if (lengthNumber >= this.maxLength) {
            event.preventDefault();
            return;
          }
        }
      } else {
        if (this.isDecimal) {
          const lengthDecimal = ((amount + "").split(".")[1] || "").length;
          if (lengthDecimal >= this.maxLengthDecimal) {
            event.preventDefault();
            return;
          }
        }
      }
    }

    if (key < "0" || key > "9") {
      event.preventDefault();
      return;
    }
    return;
  }
  isDifferentNullAndUndefined(amount?) {
    return amount !== null && amount !== undefined;
  }

  selectAll() {
    if (this.disabled || !this.maxAvailable) {
      return; // Không làm gì nếu input bị disabled hoặc không có maxAvailable
    }

    // Đặt giá trị tối đa
    this.amount = this.maxAvailable;
    this.amountText = this.formatAmount(this.maxAvailable);

    // Kiểm tra và định dạng theo ràng buộc
    this.validateAndFormat();

    // Phát sự kiện ra ngoài
    this.amountChange.emit(this.amount);
    this.result.emit(this.amount);
  }

  // Hàm định dạng số theo maxLengthDecimal
  private formatAmount(value: number): string {
    if (!this.isDecimal) {
      return Math.floor(value).toString();
    }
    return value.toFixed(this.maxLengthDecimal);
  }

  // Hàm kiểm tra và định dạng lại giá trị
  private validateAndFormat() {
    let value = parseFloat(this.amountText) || 0;

    // Kiểm tra maxLength
    if (this.isDecimal && this.amountText.includes(".")) {
      const decimalPart = this.amountText.split(".")[1];
      if (decimalPart && decimalPart.length > this.maxLengthDecimal) {
        value = parseFloat(value.toFixed(this.maxLengthDecimal));
        this.amountText = this.formatAmount(value);
      }
    }

    // Kiểm tra maxLength cho phần nguyên
    const integerPart = Math.floor(value).toString();
    if (integerPart.length > this.maxLength) {
      value = parseFloat(integerPart.substring(0, this.maxLength));
      this.amountText = this.formatAmount(value);
    }

    // Cập nhật amount
    this.amount = value;
  }
}
